import React from "react";
import { MDBTooltip } from "mdb-react-ui-kit";
import Loading from "../Loading";
import { timeStringWithAmPm } from "../utilities/utils";
import History from "../../constants/History";

const OpenBetsTable = ({
  openBetsInfo,
  getDateUTCFormat,
  voidWager,
  loading,
  openWagerDetailsModal,
}) => {
  let headers,
    tableContent = [],
    detailsTicket = [],
    detailsIdSport = [];

  //Charge Open Bets Table
  if (openBetsInfo) {
    tableContent = openBetsInfo.map((data, i) => {
      detailsTicket = [];
      detailsIdSport = [];
      const hasCB = data.IDProduct === History.IDProductCB;
      if (hasCB) {
        detailsIdSport.push(
          <p
            key={"cbLabel"}
            style={{
              margin: "0px",
              marginTop: "5px",
              marginBottom: "2px",
              textAlign: "center",
              whiteSpace: "nowrap",
            }}
          >
            <MDBTooltip
              tag="span"
              wrapperProps={{ href: "#" }}
              title="Chat Bet"
            >
              <span
                style={{
                  borderRadius: "20px",
                  fontSize: "0.75rem",
                  color: "#fff",
                }}
                class="badge bg-info px-2"
              >
                CB
              </span>
            </MDBTooltip>
          </p>,
        );
      } else {
        detailsIdSport.push(
          <p
            key={"headerSpacer"}
            style={{
              margin: "0px",
              marginTop: "5px",
              marginBottom: "2px",
            }}
          >
            &nbsp;
          </p>,
        );
      }
      data.Details.forEach((detail, j) => {
        detailsIdSport.push(
          <p
            key={"detSport" + j}
            style={{
              margin: "0px",
              textAlign: "center",
              whiteSpace: "nowrap",
            }}
          >
            {detail.IDSport}
          </p>,
        );
        detailsTicket.push(
          <p
            className=""
            key={"detDesc" + j}
            style={{
              width: "280px",
              wordWrap: "break-word",
              whiteSpace: "normal",
            }}
          >
            {detail.IsSGP && (
              <span
                style={{
                  borderRadius: "20px",
                  fontSize: "0.75rem",
                  color: "#fff",
                  marginRight: "10px",
                }}
                class="badge bg-primary"
              >
                SGP
              </span>
            )}
            {detail.IsEarlyPO && (
              <MDBTooltip
                tag="span"
                wrapperProps={{ href: "#" }}
                title="Early Payout"
              >
                <span
                  style={{
                    borderRadius: "20px",
                    fontSize: "0.75rem",
                    color: "#fff",
                    marginRight: "10px",
                  }}
                  class="badge bg-success"
                >
                  EP
                </span>
              </MDBTooltip>
            )}
            {detail.DetailDescription}
          </p>,
        );
      });
      return (
        <React.Fragment key={i}>
          <tr
            key={"tr" + data.TicketNumber}
            style={{ verticalAlign: "middle", cursor: "pointer" }}
            className={"entryTR"}
            onDoubleClick={() => openWagerDetailsModal(data)}
          >
            <td className="d-none">{data.IdWager}</td>

            <td
              key={"td" + data.TicketNumber}
              style={{
                textAlign: "center",
                width: "100px",
                verticalAlign: "middle",
              }}
            >
              <p style={{ margin: "0px" }}>
                {getDateUTCFormat(data.PlacedDate)}
              </p>
              <p>{timeStringWithAmPm(data.PlacedDate)}</p>
            </td>
            <td
              key={"userPl" + data.IdWager}
              style={{
                textAlign: "center",
                verticalAlign: "middle",
                width: "100px",
              }}
            >
              <p style={{ margin: "0px" }}>{data.LoginName}</p>
              <p>{data.PhoneLine}</p>
            </td>

            <td
              key={"sport" + data.IdWager}
              style={{
                textAlign: "center",
                verticalAlign: "top",
                whiteSpace: "nowrap",
              }}
            >
              {detailsIdSport}
            </td>

            <td
              key={"desc" + data.IdWager}
              style={{
                verticalAlign: "top",
                width: "280px",
              }}
            >
              <p
                className="text-center"
                key={"hDesc" + data.IdWager}
                style={{
                  marginBottom: "2px",
                  marginTop: "5px",
                }}
              >
                {data.HeaderDescription}
              </p>
              {detailsTicket}
            </td>

            <td
              key={"td"}
              style={{
                textAlign: "center",
                verticalAlign: "middle",
              }}
            >
              {data.RiskAmount} / {data.WinAmount}
            </td>
            <td
              style={{
                textAlign: "center",
                verticalAlign: "middle",
              }}
            >
              <MDBTooltip tag="i" wrapperProps={{ href: "#" }} title="Void">
                <i
                  className="feather icon-trash-2"
                  style={{
                    color: "#ff0000",
                    fontSize: "20px",
                    cursor: "pointer",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    voidWager(data);
                  }}
                ></i>
              </MDBTooltip>
            </td>
          </tr>
        </React.Fragment>
      );
    });
  }

  headers = (
    <tr className="text-center header-tbEntries">
      <th hidden>TicketID</th>
      <th style={{ width: "100px" }}>Placed</th>
      <th>User / PL</th>
      <th></th>
      <th>Description</th>
      <th>Risk / Win</th>
      <th></th>
    </tr>
  );
  return (
    <>
      {loading && <Loading />}
      <div style={{ height: "500px", overflow: "auto", marginTop: "10px" }}>
        <table className="table table-striped table-sm">
          <thead style={{ position: "sticky", top: "0", background: "white" }}>
            {headers}
          </thead>
          <tbody className="table-sm">{tableContent}</tbody>
        </table>
      </div>
    </>
  );
};

export default OpenBetsTable;
